import { useState, useEffect } from 'react';
import { postIpaffsCategories } from '../apiCalls';

export const useIpaffsModalDetailedData = (itemsRows, show) => {
  const [data, setData] = useState({
    data: [],
  });
  useEffect(() => {
    if (itemsRows?.length && show) {
      async function fetchData() {
        const formData = new FormData();
        formData.append('Items', JSON.stringify(itemsRows)); // Convert itemsRows to JSON string
        // const dataToSend = { Items: itemsRows }; // Match the backend's expected structure
        try {
          const dataResponse = await postIpaffsCategories(formData);

          if (!dataResponse) {
            setData([]);
          } else setData(JSON.parse(dataResponse));
        } catch (error) {
          console.error('Error fetching data:', error);
        }
      }
      fetchData();
    }
  }, [itemsRows, show]);

  return data;
};
